// Auth0 gives one free-text string on deny, and every deny looks alike to the app.
// This case carries a marker so it can be told apart, and data only rather than
// prose: display text is localized here, and the sender cannot localize.

const ACCOUNT_NOT_PROVISIONED = 'ACCOUNT_NOT_PROVISIONED';

export interface AccountNotProvisionedDetail {
    /** Email or name, for the user to recognise the account. */
    username?: string;
    /** The username to enter in Add user. */
    loginName?: string;
    idp?: string;
}

// Values arrive from an editable query string, so only non-empty strings are used.
const asDisplayableString = (value: unknown): string | undefined =>
    typeof value === 'string' && value.length > 0 ? value : undefined;

const parseJson = (value: string): unknown => {
    try {
        return JSON.parse(value);
    } catch {
        return undefined;
    }
};

// Returns detail only for a recognised payload. Prose from other deny sites,
// malformed input and unknown reasons all fall through to the generic screen.
export const parseAuthFailureDetail = (
    errorDescription: string | undefined,
): AccountNotProvisionedDetail | undefined => {
    if (!errorDescription) {
        return undefined;
    }

    const parsed = parseJson(errorDescription);

    if (
        typeof parsed !== 'object' ||
        parsed === null ||
        Array.isArray(parsed) ||
        (parsed as { reason?: unknown }).reason !== ACCOUNT_NOT_PROVISIONED
    ) {
        return undefined;
    }

    const { username, loginName, idp } = parsed as Record<string, unknown>;

    return {
        ...(asDisplayableString(username) && {
            username: asDisplayableString(username),
        }),
        ...(asDisplayableString(loginName) && {
            loginName: asDisplayableString(loginName),
        }),
        ...(asDisplayableString(idp) && { idp: asDisplayableString(idp) }),
    };
};
